// extracted by mini-css-extract-plugin
module.exports = {"exclamation_margin_right":"FinesYes_exclamation_margin_right__3iUTd","margin_back":"FinesYes_margin_back__3pWT6","blockquote_font":"FinesYes_blockquote_font__3MWP8"};